webpackJsonp([126990158671820],{

/***/ 325:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>The Dashboard has a fully integrated lead management system to track a sales teams or individuals leads.</p>","frontmatter":{"date":"September 04, 2018","path":"/leads","title":"Leads"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---leads-c5e1c6c301f2443c7891.js